<template>
  <div class="brand--option white pa-4 rounded-lg elevation-2">
    <input v-model="appointmentBrand" :value="brand.id" type="radio" :id="brand.name" class="d-none" :disabled="disabled" />
    <label class="d-flex align-center justify-start" style="height: 100%" :for="brand.name">
      <span class="brand--option__radio-button mr-4"></span>
      <div class="brand-image mr-4 d-flex">
        <img width="150px" class="m-auto" :src="brand.image" />
      </div>
      <div class="brand--option__description mr-4">
        <h4 class="primary--text text--darken-1 text-body-1 font-weight-bold">
          {{ brand.name }}
        </h4>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    brand: { type: Object, required: true },
    value: { type: Number },
    disabled: { type: Boolean }
  },

  computed: {
    appointmentBrand: {
      get() {
        return this.value
      },
      set(brand) {
        this.$emit('input', brand)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.brand--option__radio-button {
  position: relative;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid var(--v-primary-darken1);
  border-radius: 99999vw;
  box-shadow: 0 2px 6px 2px var(--v-secondary-lighten5), inset -1px -1px 1px 1px rgba(var(--v-secondary-lighten5), 0.2);
  flex-grow: 0;
  flex-shrink: 0;
}

.brand--option__radio-button::before {
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  content: '';
  border-radius: 50%;
  transition: opacity 100ms ease-in;
}

.brand--option input:not(:checked) + label > .brand--option__radio-button::before {
  opacity: 0;
}

.brand--option input:checked + label > .brand--option__radio-button::before {
  @include green-gradient(90deg);
  opacity: 1;
}

.brand-image {
  height: 100%;
  img {
    object-fit: contain;
    flex-shrink: 0;
    height: 75px;
    @media only screen and (min-width: 1000px) {
      max-height: 200px;
    }
  }
}
</style>
